import useSWR from 'swr';

import { getClinics } from '@/api/clinics';
import { ENDPOINTS } from '@/api/endpoints';
import { useUserProfile } from '@/states/user-profile';

export const useGetClinics = () => {
  const { profile } = useUserProfile();
  const isVitaziAdmin = profile.role === 'vitaziadmin';

  const { data, isLoading, mutate } = useSWR(
    isVitaziAdmin ? ENDPOINTS.CLINICS : null,
    () => getClinics(),
    { revalidateOnFocus: false }
  );

  return { loading: isLoading, clinics: data, refetchClinics: mutate };
};
